// @ts-strict-ignore
import React, { ComponentType } from 'react';
import styled, { css } from 'styled-components';
// eslint-disable-next-line import/no-namespace
import * as SS from 'styled-system';
import {
  ColorProps,
  DisplayProps,
  HeightProps,
  MaxHeightProps,
  MaxWidthProps,
  OpacityProps,
  SpaceProps,
  WidthProps,
} from 'styled-system';

import {
  SocialIconComponentByName,
  SocialIconName,
} from './SocialIconComponentByName';

const DIRECTIONS = {
  up: 0,
  down: 180,
  left: 90,
  right: -90,
};
type Direction = 'up' | 'down' | 'left' | 'right';

type Props = ColorProps &
  WidthProps &
  MaxWidthProps &
  HeightProps &
  MaxHeightProps &
  SpaceProps &
  DisplayProps &
  OpacityProps & {
    name?: SocialIconName;
    className?: string;
    direction?: Direction;
    verticalAlign?: string;
    component?: ComponentType<{
      className?: string;
    }>;
    fill?: string;
    stroke?: string;
    strokeWidth?: string | number;
  };

export const SocialIcon = styled(
  ({
    name,
    width,
    maxWidth,
    height,
    maxHeight,
    className,
    direction,
    verticalAlign,
    display,
    component,
    fill,
    stroke,
    strokeWidth,
    opacity,
    ...props
  }: Props) => {
    const IconComponent = component || SocialIconComponentByName[name];
    if (!IconComponent) return null;

    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <IconComponent className={className} {...props} />;
  }
)`
  && {
    ${(props) => css`
      * {
        ${props.fill &&
        `
          fill: ${props.fill};
        `}
        ${props.stroke &&
        `
          stroke: ${props.stroke};
        `}
        ${props.strokeWidth &&
        `
          stroke-width: ${props.strokeWidth};
        `}
      }
      ${props.direction &&
      `
        transform: rotate(${DIRECTIONS[props.direction]}deg);
      `}
      ${props.verticalAlign &&
      `
        vertical-align: ${props.verticalAlign};
      `}
    `}
  }
  ${SS.space} ${SS.display} ${SS.opacity} ${SS.width} ${SS.height} ${SS.maxWidth} ${SS.maxHeight}
`;
